<div class="custom-snackbar">
    @if (data.icon) {
    <mat-icon>
        {{ data.icon }}
    </mat-icon>
    }

    <span>{{ data.message }}</span>

    <lib-button (click)="dismiss()" text="OK" color="none" textColor="primary">
        <mat-icon>close</mat-icon>
    </lib-button>
</div>